module.exports = __webpack_public_path__ + "media/images/bnr-download-13165d5715442adcd6985be81bcda440.png";